export default class Config {
  constructor() {
    this.environmentalConfigs = {
      local: {
        environment: "local",
        siteBase: "http://localhost:8081",
        serviceBase: "http://localhost:49978",
        auth0: {
          clientId: "ijkyjyQDI0FrnM4WhqiHRkkctVbu5NNy",
          clientDomain: "auth-dev.frozenmountain.com",
          redirectTo: "/auth0/callback",
          redirectAfter: "/#/auth0-callback",
          audience: "https://auth-dev.frozenmountain.com/api/v2/",
        },
        chargeBee: {
          site: "frznmtn-test"
        },
        codepenGatewayUrl: "http://localhost:8080/sync/"
      },
      hosted: {
        /* Note: these GUIDs are replaced with the correct values via script in k8 hosted environments. */
        environment: "prod",
        siteBase: "https://console.liveswitch.io",
        serviceBase: "https://api.liveswitch.io",
        auth0: {
          clientId: "Ink6J3cK05PMTl9mPaeydKaY8z1koNDe",
          clientDomain: "auth.frozenmountain.com",
          redirectTo: "/auth0/callback",
          redirectAfter: "/#/auth0-callback",
          audience: "https://auth.frozenmountain.com/api/v2/",
        },
        chargeBee: {
          site: "frznmtn"
        },
        codepenGatewayUrl: "https://cloud.liveswitch.io/"
      }
    };

    var envConfig = this.environmentalConfigs.hosted; // default
    if (window.location.hostname.includes("localhost")) {
      envConfig = this.environmentalConfigs.local;
    }

    this.environment = envConfig.environment;
    this.auth0 = envConfig.auth0;
    this.chargeBee = envConfig.chargeBee;
    this.siteBase = envConfig.siteBase;
    this.serviceBase = envConfig.serviceBase;
    this.codepenGatewayUrl = envConfig.codepenGatewayUrl;
  }
}
